<template>
  <b-modal
    :size="sizeModal"
    title="Vista Previa"
    id="modal-vista-previa-crucigrama"
    ref="modalVistaPreviaCrucigrama"
    @shown="active"
  >
    <b-row>
      <b-col cols="12" style="text-align:right; margin-bottom:20px;">
        <button @click="descargarPdf" class="btn btn-primary">Descargar PDF</button>
      </b-col>
    </b-row>
    <div id="toCanvas">
      <b-row>
        <b-col cols="12">
          <p>INSTRUCCIONES:</p>
          <p v-html="newData.instrucciones" style="white-space: normal;"></p>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <table>
            <tr v-for="(row, y) in newData.matrix" :key="y">
              <td
                v-for="(cell, x) in row"
                :key="x"
                :class="{empty: cell.empty, start: !!cell.start}"
              >
                <label v-if="!!cell.start">{{cell.start}}</label>
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>
      <b-row style="margin-top:1em; text-align: left; white-space: normal;">
        <b-col cols="6">
          <ul>
            <li>HORIZONTALES:</li>
            <li v-for="(pH,index) in pistasH" :key="index">{{pH.num}}.- {{pH.pista}}</li>
          </ul>
        </b-col>
        <b-col cols="6">
          <ul>
            <li>VERTICALES:</li>
            <li v-for="(pV,index) in pistasV" :key="index">{{pV.num}}.- {{pV.pista}}</li>
          </ul>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default {
  name: "modal-vista-previa-crucigrama",
  props: {
    contenido: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      selected: undefined,
      data: this.contenido,
      newData: Object.assign({}, this.contenido),
      sizeModal: "md",
      pistasH: [],
      pistasV: []
    };
  },
  created() {},
  methods: {
    active() {
      console.log(this.newData);
      if (this.data.horizontal > 12) {
        this.sizeModal = "lg";
      }
      // ARMAR LA LISTA DE LAS PALABRAS HORIZONTALES Y VERTICALES
      this.data.palabras.forEach((el, index) => {
        let pistaData = { pista: el.pista, num: index + 1 };
        if (el.sentido == 0) {
          this.pistasH.push(pistaData);
        } else {
          this.pistasV.push(pistaData);
        }
      });
      console.log(this.pistasH);
      console.log(this.pistasV);
    },
    close() {
      this.$bvModal.hide("modal-vista-previa-crucigrama");
    },
    descargarPdf() {
      let element = document.querySelector("#toCanvas");
      html2canvas(element, {
        scrollX: 0,
        scrollY: 0
      })
        .then(canvas => {
          var imgData = canvas.toDataURL("image/png");
          var pdf = new jsPDF("p", "mm", "a4");
          var width = (pdf.internal.pageSize.getWidth() - 10) / 1.5;
          var height = (pdf.internal.pageSize.getHeight() - 20) / 1.5;
          pdf.addImage(imgData, "JPEG", 35, 5, width, height);
          pdf.save("crucigrama.pdf");
        })
        .catch(error => {
          console.log("Erorr descargando PDF", error);
        });
    }
  }
};
</script>

<style scoped>
ul {
  list-style: none;
  padding: 0;
}
.container {
  margin-top: 3vh;
}
.table-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
table {
  border-collapse: collapse;
  font-size: 16px;
  margin: 0;
  width: 100%;
}
td {
  width: 36px;
  height: 36px;
  border: 1px solid black;
  text-align: center;
  position: relative;
  text-transform: uppercase;
  font-family: arial;
}
td.empty {
  background: #cccccc;
}
td.selected {
  background: lightblue;
}
td.start label {
  position: absolute;
  top: 0;
  left: 2px;
  text-align: left;
  font-size: 10px;
}
.mensaje {
  position: absolute;
  color: white;
  left: 25vw;
  text-align: center;
  border-radius: 8px;
  padding: 10px;
  width: 50vw;
  z-index: 1000;
  background: rgba(0, 0, 255, 0.9);
}
.mensaje button {
  margin-top: 10px;
}
.list-group-item {
  border: none !important;
}
.incorrecta-palabra {
  color: red;
}
</style>